const faqData = [
  {
    id: 1,
    que: "Does PyLoan provide loans?",
    ans: "No. PyLoan does not lend money, approve applications, arrange loans or connect applicants with lenders. We publish general educational information only.",
  },
  {
    id: 2,
    que: "Can PyLoan guarantee loan approval?",
    ans: "No. Only the relevant lender or scheme authority can assess an application. Approval, amount, interest rate, fees, collateral requirements and repayment terms depend on applicable rules and the applicant's circumstances.",
  },
  {
    id: 3,
    que: "Where should I apply?",
    ans: "Please use the official government portal or contact a bank or financial institution directly. PyLoan does not accept or process loan applications.",
  },
  {
    id: 4,
    que: "What should I check before applying?",
    ans: "Check the current eligibility rules, documents, interest rate, fees, repayment schedule, collateral or security requirements and the official application route before sharing any information.",
  },
  {
    id: 5,
    que: "Can scheme rules change?",
    ans: "Yes. Eligibility conditions, rates, limits, required documents and application procedures can change. Verify the latest details with the relevant official government portal or financial institution.",
  },
];

export default faqData;
